export class Classeur{
     id : number ;
     description: string;
     archive: boolean;
     
     constructor(data:any) {
         Object.assign(this, data);
     }
 }